import * as React from 'react';
import { IconButton, Tooltip } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Help } from '@material-ui/icons';

export interface Props {
  classes: any;
  text: string;
}

const styles = {
  button: {
    height: 20,
    left: 5,
    padding: 0,
    top: 0,
    width: 20,
  },
  icon: {
    height: 17,
    width: 17,
  },
  tooltipStyle: {
    color: 'white',
    fontSize: 14,
    lineHeight: 1.5,
    maxWidth: 300,
    width: 280,
  },
};

export const ToriiTooltip = (props: Props) => (
  <Tooltip title={props.text} classes={{ tooltip: props.classes.tooltipStyle }}>
    <IconButton
      aria-label={props.text}
      disableRipple
      classes={{ root: props.classes.button }}
    >
      <Help className={props.classes.icon} />
    </IconButton>
  </Tooltip>
);

export default withStyles(styles)(ToriiTooltip);
